import {config} from 'config/env';
import {GET_STORES_BY_ZIPCODE_SUB_DISTRICT} from 'queries/addresses';
import {getStoreInfoByLocationV2} from 'services/location/location-service';
import {StoreInfo} from 'types';
import {addressApolloClientWithToken} from 'utils';

class MultiStoreServiceClass {
  async getStoreInfoByLocation(
    idToken: string,
    zipcode: string,
    subdistrict: string,
    isExpress?: boolean
  ): Promise<StoreInfo> {
    if (config.IS_LOCATION_SVC_ENABLED) {
      const stores = await getStoreInfoByLocationV2(idToken, zipcode, subdistrict);
      return {
        ...stores,
        stores: stores?.stores?.filter((item) => (isExpress ? item.isExpress : !item.isExpress || item.isRegular))
      };
    }
    const userApolloClient = addressApolloClientWithToken(idToken as string);
    const {data} = await userApolloClient.query({
      query: GET_STORES_BY_ZIPCODE_SUB_DISTRICT,
      variables: {
        zipcode,
        subdistrict
      }
    });
    return data.queryStores;
  }
}

export const MultiStoreService = new MultiStoreServiceClass();
export default MultiStoreService;
